let freshLoginPending = false;

export const markFreshLogin = (): void => {
  freshLoginPending = true;
};

export const hasFreshLogin = (): boolean => freshLoginPending;

export const clearFreshLogin = (): void => {
  freshLoginPending = false;
};